import AgentCard from './AgentCard';
import type { AgentCard as AgentCardModel } from '../types';
import type { LoopState } from '../../../apps/apis/commandCenter/types';

interface AgentGridProps {
  slug: string;
  cards: AgentCardModel[];
  codeOf: (id: string) => string | null;
  onOpen: (id: string) => void;
  onCopyCode: (code: string) => void;
  onLoopTransition?: ((loopId: string, toState: LoopState) => void) | undefined;
  onLoopRemove?: ((loopId: string) => void) | undefined;
  onLoopConnect?: ((loopId: string) => void) | undefined;
  onLoopDisconnect?: ((loopId: string) => void) | undefined;
}

/** Read-only card grid. */
const AgentGrid = ({
  slug,
  cards,
  codeOf,
  onOpen,
  onCopyCode,
  onLoopTransition,
  onLoopRemove,
  onLoopConnect,
  onLoopDisconnect,
}: AgentGridProps) => {
  return (
    <div className="fleet" id={`fleet-${slug}`}>
      {cards.length === 0 ? <div className="empty">no managed skills in this section</div> : null}
      {cards.map((card) => (
        <AgentCard
          key={card.id}
          card={card}
          code={codeOf(card.id)}
          onOpen={() => onOpen(card.id)}
          onCopyCode={onCopyCode}
          onLoopTransition={onLoopTransition}
          onLoopRemove={onLoopRemove}
          onLoopConnect={onLoopConnect}
          onLoopDisconnect={onLoopDisconnect}
        />
      ))}
    </div>
  );
};

export default AgentGrid;
